import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mt-5 rounded border border-gray-200 bg-gray-50 px-3.5 py-3",
  "data-cy": "conflict-field-filter"
}
const _hoisted_2 = { class: "mb-2 flex flex-wrap items-center gap-3" }
const _hoisted_3 = {
  class: "text-xs text-gray-500",
  "data-cy": "conflict-filter-status"
}
const _hoisted_4 = { class: "ml-1.5 tabular-nums normal-case opacity-70" }

import { computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import {
  CONFLICT_FIELD_GROUPS,
  CONFLICT_GROUP_CLASSES,
  conflictFieldGroup,
  conflictFieldLabel,
} from '../constants/conflictFieldConstants';
import type { ConflictFieldId } from '../models/conflictTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictFieldFilter',
  props: {
    fieldCounts: {},
    hiddenFields: {},
    hiddenRowCount: {},
    permittedFields: {},
    includedTimeEntries: { type: Boolean }
  },
  emits: ["toggle", "showAll"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const anyHidden = computed(() => props.hiddenFields.length > 0);

const statusText = computed(() =>
  props.hiddenRowCount
    ? `${props.hiddenRowCount} result${
        props.hiddenRowCount === 1 ? '' : 's'
      } hidden`
    : 'Click a field to hide its results',
);

const label = (field: ConflictFieldId) => conflictFieldLabel(field);

const allowed = (fields: ConflictFieldId[]) =>
  fields.filter((field) => props.permittedFields.indexOf(field) !== -1);

function isUnsearched(field: ConflictFieldId): boolean {
  return field === 'timeEntryDescription' && !props.includedTimeEntries;
}

/** No results and nothing to toggle — shown so the field still reads as searched. */
function isDead(field: ConflictFieldId): boolean {
  return isUnsearched(field) || !props.fieldCounts[field];
}

function countLabel(field: ConflictFieldId): string {
  if (isUnsearched(field)) return 'not searched';
  return String(props.fieldCounts[field] ?? 0);
}

function chipClasses(field: ConflictFieldId): string[] {
  if (props.hiddenFields.indexOf(field) !== -1)
    return ['line-through', 'opacity-60'];
  if (isDead(field)) return ['opacity-50'];
  return [CONFLICT_GROUP_CLASSES[conflictFieldGroup(field)]];
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-xs font-medium uppercase tracking-wider text-gray-500" }, " Searched fields ", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(statusText.value), 1),
      _createVNode(LlSecondaryButton, {
        variant: "text",
        size: "small",
        class: _normalizeClass(["ml-auto", { invisible: !anyHidden.value }]),
        tabindex: anyHidden.value ? 0 : -1,
        "data-cy": "conflict-show-all-fields",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('showAll')))
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Show all fields ", -1)
        ]))]),
        _: 1
      }, 8, ["class", "tabindex"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CONFLICT_FIELD_GROUPS), (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.key,
        class: "flex flex-wrap gap-1.5 py-1"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowed(group.fields), (field) => {
          return (_openBlock(), _createBlock(_component_v_chip, {
            key: field,
            size: "small",
            label: "",
            variant: "outlined",
            disabled: isDead(field),
            class: _normalizeClass(chipClasses(field)),
            "aria-pressed": String(__props.hiddenFields.indexOf(field) === -1),
            "data-cy": `conflict-field-chip-${field}`,
            onClick: ($event: any) => (emit('toggle', field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(label(field)) + " ", 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(countLabel(field)), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "class", "aria-pressed", "data-cy", "onClick"]))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})